import React, { Fragment } from 'react';

const TripRequestSF = ({ city = 'toronto' }) => (
  <Fragment>
    <p>
      There are several possible reasons why you are not receiving any
      trip/delivery requests:
    </p>
    <ol>
      <li>
        <strong>Low demand:</strong> There is currently less demand for
        rideshare services in your current area. Try avoiding areas where
        there is surge pricing or higher than expected demand which can be
        determined by using the Uber Driver app.
      </li>
      <li>
        <strong>Missing Uber requirement:</strong> To drive Uber, you must
        have your background check complete or renewed yearly. Contact Uber
        Support at (1-800-593-7069) to confirm if there are any documents
        that you need to submit.
      </li>
      <li>
        <strong>Poor Network Connection/Data Plan:</strong> You may be
        having difficulties with connecting with your service provider or
        your data plan is not sufficient.
      </li>
    </ol>
  </Fragment>
);

export default TripRequestSF;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/AccountIssues/TripRequestSF.js